<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ gameName }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_viewType') }}
            span(slot="value") {{ $i18n.t('couples.couples_view_' + parameters.viewType)  }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfLinks') }}
            span(slot="value") {{ parameters.amountOfLinks }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
            span(slot="value") {{ parameters.numOfExamples }}
        game-preview-setting(v-if="parameters.withTime")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_linkShowTime') }}
            span(slot="value") {{ parameters.showTime }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
        game-preview-setting(v-if="!parameters.withTime")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}
            span(slot="value") {{ getModeName(parameters.mode) }}
        game-preview-setting(v-if="parameters.viewType === 'word'")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_difficultWords') }}
            span(slot="value")
                template(v-if="parameters.difficultWords") {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
                template(v-else) {{ $i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated') }}
</template>

<script>
    /*eslint-disable*/
    import GamePreviewSettings from './GamePreviewSettings.vue'
    import GamePreviewSetting from './GamePreviewSetting.vue'
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin'

    export default {
        props: {
            parameters: Object,
            exerciseId: [Number, String],
            type: String
        },
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting
        },
        computed: {
            gameName () {
                return this.parameters.withTime
                        ? this.$i18n.t('common.common_gameName_chainsWithTime')
                        : this.$i18n.t('common.common_gameName_chains');
            },
        }
    }
</script>
